import { render, staticRenderFns } from "./ProblemNewPopup.vue?vue&type=template&id=12e395ed&scoped=true&"
import script from "./ProblemNewPopup.vue?vue&type=script&lang=js&"
export * from "./ProblemNewPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProblemNewPopup.vue?vue&type=style&index=0&id=12e395ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e395ed",
  null
  
)

export default component.exports